import {useState} from 'react';

export function useImageSelection() {
  const [selectedImageIds, setSelectedImageIds] = useState<Set<string>>(new Set());

  const getSelectedImages = () => Array.from(selectedImageIds);

  const isImageSelected = (imageId: string) => selectedImageIds.has(imageId);

  const selectImage = (imageId: string) => {
    setSelectedImageIds((previousSelection) =>
      previousSelection.has(imageId) ? previousSelection : new Set(previousSelection).add(imageId)
    );
  };

  const deselectImage = (imageId: string) => {
    setSelectedImageIds((previousSelection) => {
      if (!previousSelection.has(imageId)) {
        return previousSelection;
      }
      const updatedSelection = new Set(previousSelection);
      updatedSelection.delete(imageId);
      return updatedSelection;
    });
  };

  const selectImagesInBulk = (imageIds: string[]) => {
    setSelectedImageIds(new Set(imageIds));
  };

  const clearImageSelection = () => {
    setSelectedImageIds(new Set());
  };

  const toggleImageSelection = (imageId: string) => {
    setSelectedImageIds((previousSelection) => {
      const updatedSelection = new Set(previousSelection);
      if (updatedSelection.has(imageId)) {
        updatedSelection.delete(imageId);
      } else {
        updatedSelection.add(imageId);
      }
      return updatedSelection;
    });
  };

  return {
    selectedImageIds,
    selectedCount: selectedImageIds.size,
    getSelectedImages,
    isImageSelected,
    selectImage,
    deselectImage,
    selectImagesInBulk,
    clearImageSelection,
    toggleImageSelection,
  };
}
